import React from 'react';
import {useBridge} from '@providers/BridgeProvider';
import type {WebviewBridgeEmitter} from '@deezer/webview-bridge';
import {ViewState} from '@deezer/webview-bridge';

type Props = {
	children: React.ReactNode;
	updateViewState: WebviewBridgeEmitter['updateViewState'];
};
class InternalBridgeViewStatusUpdater extends React.Component<Props> {
	constructor(props: Props) {
		super(props);
	}

	componentDidCatch(error: never) {
		try {
			this.props.updateViewState(ViewState.ERROR, error);
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(error);
		}
	}
	componentDidUpdate() {
		try {
			this.props.updateViewState(ViewState.SUCCESS);
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(error);
		}
	}

	render() {
		return <>{this.props.children}</>;
	}
}

const BridgeViewStatusUpdater: React.FC<{children: React.ReactNode}> = ({
	children = null,
}) => {
	const bridge = useBridge();
	if (!bridge) {
		return children;
	}
	return (
		<InternalBridgeViewStatusUpdater
			updateViewState={bridge.updateViewState.bind(bridge)}
		>
			{children}
		</InternalBridgeViewStatusUpdater>
	);
};

export default BridgeViewStatusUpdater;
